import { $win, $body, $doc } from "../utils/globals";
import isMobile from '../utils/isMobile';

$('.nav-trigger').on('click', function(e) {
    e.preventDefault();

    $body.toggleClass('nav-visible');
});

$doc.on("click", function(e) {
  if ( !e.target.closest("header .nav") && !e.target.closest(".nav-trigger") ) {
    $body.removeClass('nav-visible');
  }
});

$win.on('resize', function () {
    if ( $(this).width() > 1024 ) {
        $body.removeClass('nav-visible');
    }
})
